module.exports = __webpack_public_path__ + "static/media/post_1.40a3ef70.jpeg";